import { render, staticRenderFns } from "./IPUView.vue?vue&type=template&id=440c67f2&"
import script from "./IPUView.vue?vue&type=script&lang=js&"
export * from "./IPUView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports